import { useState } from "react";
import { useContextLandingPages } from "src/Contexts/LandingPageContext/LandingPagesContext";
import { valuesDefaultInputsLandingPages } from "src/Contexts/LandingPageContext/valuesDefaultInputsLandingPages/ValueDefaultInputLandingPages";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";
import { apenasNumeros } from "src/shared/Utils/FormatMoney";
import { handleFormatDateIfIsNull } from "src/shared/Utils/handleFormatDateIfIsNull";

export const useFormLandingPagePublic = () => {
  const { handleGetAlert } = useLayoutMainContext();
  const { valuesInputsLeads, idLandingPage, idTenant, setValuesInputsLeads } =
    useContextLandingPages();

  const [loading, setLoading] = useState(false);

  const resultData = {
    ...valuesInputsLeads,

    cpf: apenasNumeros(valuesInputsLeads?.cpf || "") || "",

    whats: apenasNumeros(valuesInputsLeads?.whats || "") || "",

    entityType:
      valuesInputsLeads?.entityType !== " "
        ? valuesInputsLeads?.entityType
        : undefined,

    interestLevel: "HIGH",
    sourceCollection: "LADING_PAGE",
    status: "NEW",

    captureAt: handleFormatDateIfIsNull(new Date().toISOString()),

    isPlan:
      valuesInputsLeads?.isPlan === "TRUE"
        ? true
        : valuesInputsLeads?.isPlan === "FALSE"
        ? false
        : null,

    // captureAt: handleFormatDateIfIsNull(valuesInputsLeads.captureAt),

    descriptionPlan: valuesInputsLeads?.descriptionPlan || undefined,

    idLandingPage,
    idTenant,
  };

  const handleSubmit = async () => {
    if (!resultData.name?.trim())
      return handleGetAlert({ message: `Digite um nome` });

    setLoading(true);

    return api
      .post("/public/landing-page/create-lead", resultData)
      .then((res) => {
        handleGetAlert({ message: res.data.message });
        setValuesInputsLeads(valuesDefaultInputsLandingPages);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  return { handleSubmit, loading };
};
